// @ts-nocheck
import React, { useState, useRef } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import withStyles from "isomorphic-style-loader/withStyles";

import ChevronUp from "app/components/Icons/ChevronUp";
import ChevronDown from "app/components/Icons/ChevronDown";

import classes from "./styles.scss";

interface Props {
	label: string;
	className?: string;
	disabled: boolean;
	options: {
		label: string;
		onClick: () => void;
	}[];
}

const ButtonDropdown : React.FC<Props> = (props) => {
	const [isToggled, setIsToggled] = useState(false);
	const dropdownBtnRef = useRef(null);
	
	const {
		label,
		options,
		className,
		disabled,
		buttonClassName
	} = props;

	const dropdownContainerClasses = [classes.dropdown];
	const dropdownBtnClasses = [classes.dropbtn];

	if (className) {
		dropdownContainerClasses.push(className);
	}

	if (buttonClassName) {
		dropdownBtnClasses.push(buttonClassName);
	}

	const toggleDropdown = () => {
		setIsToggled((toggled) => !toggled);
	};

	const closeDropdown = () => {
		setIsToggled(false);
	};

	return (
		<div className={dropdownContainerClasses.join(" ")}>
			<OutsideClickHandler onOutsideClick={closeDropdown}>
				<button
					ref={dropdownBtnRef}
					onClick={toggleDropdown}
					className={dropdownBtnClasses.join(" ")}
					disabled={disabled}
					data-cy={label}
				>
					{label}

					{isToggled ? <ChevronUp /> : <ChevronDown />}
				</button>
			</OutsideClickHandler>

			<ul id="dropdownContent" className={`${classes.dropdownContent} ${isToggled ? classes.show : ""}`}>
				{options.map((option) => (
					<li
						key={option.label}
						onClick={option.onClick}
					>
						{option.label}
					</li>
				))}
			</ul>
		</div>
	);
};

export default withStyles(classes)(ButtonDropdown);
